import { cn, SvgIcon } from "@cafe/ui";
import type { NavItem } from "@/app/nav";

/** Иконка пункта навигации: из набора Figma (маска) или lucide. */
export function ItemIcon({ icon, className }: { icon: NavItem["icon"]; className?: string }) {
  if (typeof icon === "string") return <SvgIcon src={icon} className={className} />;
  const Icon = icon;
  return <Icon className={cn("size-6", className)} strokeWidth={1.5} aria-hidden />;
}
